<div class="dialog-content">
  <!-- Icon -->
  <div class="icon-wrapper">
    <mat-icon class="dialog-icon">
      {{ data.icon || 'exit_to_app' }}
    </mat-icon>
  </div>

  <!-- Title -->
  <h2 class="dialog-title">
    {{ data.title || 'Exit Interview' }}
  </h2>

  <!-- Message -->
  <p class="dialog-message">
    {{
      data.message ||
      'Once you submit the interview, you will receive feedback on your interview performance.'
    }}
  </p>

  <!-- Actions -->
  <div class="dialog-actions">
    <button class="btn btn-cancel" (click)="close(false)">
      {{ data.cancelText || 'Cancel' }}
    </button>

    <button class="btn btn-exit" (click)="close(true)">
      {{ data.confirmText || 'Exit' }}
    </button>
  </div>
</div>
